<template>
  <v-app>
    <div>
    <v-app-bar app color="primary" dark >
      <h1>NasaAPI</h1>
      <v-spacer />
    </v-app-bar>
    </div>
    <maincomp style="margin-top:30px" />
  </v-app>
</template>

<script>
import maincomp from "./components/main";
export default {
  name: "App",

  components: {
    maincomp,
  },

  data: () => ({
    //
  }),
};
</script>
